<template>
  <div style="display: flex; flex-direction: column; align-items: center">
    <Toast ref="toast" />
    <h1 style="text-align: center">Админ-панель</h1>
    <table class="lots-table">
      <thead>
        <tr>
          <th>ID</th>
          <th>Название</th>
          <th>Размеры</th>
          <th>Запрос истории</th>
          <th>Отображение лота</th>
          <th>Действия</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="lot in lots" :key="lot.id">
          <td>{{ lot.id }}</td>
          <td>
            <input type="text" v-model="editableLots[lot.id].name" />
          </td>
          <td>
            <input type="text" v-model="sizeInputs[lot.id]" @change="updateSizes(lot.id)" />
          </td>
          <td>
            <input type="checkbox" v-model="editableLots[lot.id].fetch" />
          </td>
          <td>
            <input type="checkbox" v-model="editableLots[lot.id].active" />
          </td>
          <td class="actions">
            <button @click="saveLot(lot.id)" class="save-btn">Сохранить</button>
            <button @click="confirmDelete(lot.id)" class="delete-btn">Удалить</button>
          </td>
        </tr>
      </tbody>
    </table>
    <div>
      <AddLotForm />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, reactive } from 'vue'
import AddLotForm from '@/components/AddLotForm.vue'
import Toast from 'primevue/toast'
import axios from 'axios'
import { api } from '@/api/http'

const toast = ref()

const lots = ref<any[]>([])
const editableLots = reactive<Record<string, any>>({})
const sizeInputs = reactive<Record<string, string>>({})

/**
 * LOAD LOTS
 */
const loadLots = async () => {
  try {
    const { data } = await api.get('/lots')

    lots.value = data

    data.forEach((lot: any) => {
      editableLots[lot.id] = {
        name: lot.name,
        maximum: lot.maximum,
        size: [...lot.size],
        fetch: lot.fetch,
        active: lot.active
      }

      sizeInputs[lot.id] = lot.size.join(', ')
    })
  } catch (err) {
    console.error('Ошибка загрузки лотов:', err)

    toast.value?.add({
      severity: 'error',
      summary: 'Ошибка загрузки лотов',
      life: 3000
    })
  }
}

/**
 * UPDATE SIZE INPUT
 */
const updateSizes = (id: string) => {
  const sizes = sizeInputs[id].split(',').map(item => parseFloat(item.trim()))

  editableLots[id].size = sizes.filter(item => !isNaN(item))
}

/**
 * SAVE LOT
 */
const saveLot = async (id: string) => {
  try {
    const dataToUpdate = { ...editableLots[id] }

    await api.put(`/lots/${id}`, dataToUpdate)

    const index = lots.value.findIndex(lot => lot.id === id)
    if (index !== -1) {
      lots.value[index] = {
        ...lots.value[index],
        ...dataToUpdate
      }
    }

    toast.value?.add({
      severity: 'success',
      summary: 'Изменения сохранены',
      life: 3000
    })
  } catch (err: unknown) {
    const message = axios.isAxiosError(err)
      ? err.response?.data?.message || 'Ошибка обновления лота'
      : 'Ошибка обновления лота'

    toast.value?.add({
      severity: 'error',
      summary: message,
      life: 3000
    })
  }
}

/**
 * DELETE LOT
 */
const deleteLot = async (id: string) => {
  try {
    await api.delete(`/lots/${id}`)

    lots.value = lots.value.filter(lot => lot.id !== id)

    delete editableLots[id]
    delete sizeInputs[id]

    toast.value?.add({
      severity: 'success',
      summary: 'Лот удалён',
      life: 3000
    })
  } catch (err: unknown) {
    const message = axios.isAxiosError(err)
      ? err.response?.data?.message || 'Ошибка при удалении лота'
      : 'Ошибка при удалении лота'

    toast.value?.add({
      severity: 'error',
      summary: message,
      life: 3000
    })
  }
}

/**
 * CONFIRM DELETE
 */
const confirmDelete = (id: string) => {
  if (confirm('Вы уверены, что хотите удалить этот лот?')) {
    deleteLot(id)
  }
}

onMounted(loadLots)
</script>

<style scoped>
.lots-table {
  max-width: 800px;
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  margin-bottom: 40px;
}

.lots-table th,
.lots-table td {
  text-align: center;
  border: 1px solid #ddd;
  padding: 8px;
}

.actions {
  display: flex;
  gap: 20px;
}
</style>
